// extracted by mini-css-extract-plugin
export default {"section":"TransitTab_section__t0+Jm","title":"TransitTab_title__Q7of0"};